/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from "react";
import authRoles from "../../auth/authRoles";
import Templates from "./Templates";
import InstanceWrapper from "../../shared-components/layouts/InstanceWrapper";
import TemplateView from "./instance/TemplateView";
import TemplateForm from "./instance/TemplateForm";

const TemplateConfig = {
  routes: [
    {
      path: "templates",
      element: <Templates />,
    },
    {
      path: "templates/:id",
      element: <InstanceWrapper />,
      children: [
        {
          path: "",
          element: <TemplateView />,
        },
        {
          path: "edit",
          element: <TemplateForm />,
          auth: authRoles.admin,
        },
      ]
    }
  ],
};

export default TemplateConfig;
